<template>
  <div class="main-content">
    <SectionTitle class="animate-target" v-animate-in :title="title"></SectionTitle>
    <div class="ctn-text2 animate-target" v-animate-in>Before prescribing finerenone, please refer to the full Product Information for a full list of prescribing considerations. Select considerations are described below.</div>
    <div class="ctn-text1 animate-target" v-animate-in>Contraindications</div>
    <ul>
      <li class="animate-target" v-animate-in>Taking concomitant medications that are strong CYP3A4 inhibitors e.g. itraconazole, ketoconazole, ritonavir, nelfinavir, cobicistat, clarithromycin, telithromycin and nefazodone</li>
      <li class="animate-target" v-animate-in>Adrenal insufficiency</li>
    </ul>
    <div class="ctn-text1 animate-target" v-animate-in>Hyperkalaemia</div>
    <div class="ctn-text2 animate-target" v-animate-in>High risk of developing hyperkalaemia include those with:</div>
    <ul>
      <li class="animate-target" v-animate-in>Low eGFR</li>
      <li class="animate-target" v-animate-in>Higher serum potassium</li>
      <li class="animate-target" v-animate-in>Previous episodes of hyperkalaemia</li>
    </ul>
    <div class="ctn-text1 animate-target" v-animate-in>Concomitant medications</div>
    <ul>
      <li class="animate-target" v-animate-in>Avoid: potassium-sparing diuretics (e.g., amiloride, triamterene), other mineralocorticoid receptor antagonists (MRAs) (e.g., eplerenone, spironolactone).</li>
      <li class="animate-target" v-animate-in>Caution: potassium supplements, trimethoprim, or trimethoprim-sulfamethoxazole. </li>
    </ul>
    <div class="ctn-text1 animate-target" v-animate-in>Pregnancy and lactation</div>
    <div class="ctn-text2 animate-target" v-animate-in>Use in Pregnancy (Category D)</div>
    <ul>
      <li class="animate-target" v-animate-in>Finerenone should not be used during pregnancy unless there has been careful consideration of the benefit for the mother and the risk to the foetus</li>
      <li class="animate-target" v-animate-in>Breastfeeding should be discontinued if the use of finerenone is considered essential</li>
    </ul>
    <GoNext class="animate-target" v-animate-in href="/section4/4-8">Next</GoNext>
    <ContentNotice class="animate-target" v-animate-in :txt="noticeTxt"/>
  </div>
</template>

<script>
import SectionTitle from "../../components/SectionTitle";
import GoNext from "../../components/GoNext";
import ContentNotice from "../../components/ContentNotice";
import {mapState} from "vuex";

export default {
  name: "s4-7",
  components: {SectionTitle, GoNext, ContentNotice},
  computed:{
  },
  data(){
    return{
      noticeTxt:"CYP3A4, Cytochrome P450 3A4; eGFR, estimated glomerular filtration rate.<br/><div class='brs'></div>"
      +"References:<br/><div class='brs'></div>"
      +"1. KERENDIA Product Information.",
      title:"Prescribing considerations for finerenone<sup>1</sup>"
    }
  }
}
</script>

<style scoped>
@import "../../assets/css/section4/s4.css";
.ctn-text1 {
  color: #10384F;
  font-size: 24px;
  font-weight: bold;
  margin-top:40px;
}
.ctn-text2 {
  font-size: 20px;
  margin-top: 20px;
}
ul {
  margin-top: 20px;
  padding-left: 30px;
}
ul li {
  margin-bottom: 15px;
}
</style>
